/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTimeEntryRequestAppointmentId
 */
export interface CreateTimeEntryRequestAppointmentId {
}

/**
 * Check if a given object implements the CreateTimeEntryRequestAppointmentId interface.
 */
export function instanceOfCreateTimeEntryRequestAppointmentId(value: object): value is CreateTimeEntryRequestAppointmentId {
    return true;
}

export function CreateTimeEntryRequestAppointmentIdFromJSON(json: any): CreateTimeEntryRequestAppointmentId {
    return CreateTimeEntryRequestAppointmentIdFromJSONTyped(json, false);
}

export function CreateTimeEntryRequestAppointmentIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTimeEntryRequestAppointmentId {
    return json;
}

export function CreateTimeEntryRequestAppointmentIdToJSON(json: any): CreateTimeEntryRequestAppointmentId {
    return CreateTimeEntryRequestAppointmentIdToJSONTyped(json, false);
}

export function CreateTimeEntryRequestAppointmentIdToJSONTyped(value?: CreateTimeEntryRequestAppointmentId | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

